var momentRange = function (moment, min, max) {
    return moment.range(moment(min), moment(max).add(1, 'days')).toArray('days');
}

export default momentRange
